import Loadable from '../../components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';
import loadBookingDetails from './loadBookingDetails';

const BookingOrders = Loadable(lazy(() => import('./BookingOrders')));
const BookingOrderDetails = Loadable(lazy(() => loadBookingDetails()));
const BookingAttachments = Loadable(lazy(() => import('./SubPages/BookingAttachments')));

const bookingRoutes = [
  { path: '/dashboard/booking-appointments', element: <BookingOrders />, auth: authRoles.admin },
  {
    path: '/dashboard/booking-appointments/:id/details/',
    element: <BookingOrderDetails />,
    auth: authRoles.admin,
  },
  {
    path: '/dashboard/booking-appointments/:id/details/booking-attachments',
    element: <BookingAttachments />,
    auth: authRoles.admin,
  },
];

export default bookingRoutes;
